import { PropType, defineComponent, h } from 'vue';
import { Dialog } from '@phi/components';
import FormSelect, { Entry } from '../FormSelect';
import {
    uid_select_all_objects,
} from '../../ui_display';
import { uil_get_model_bodies } from '../../ui_logic';


import { enumerate, map } from '@vaaas/fpts/iter';
import { pipe } from '@vaaas/fpts/function';
import { of } from '@vaaas/fpts/array';
import { IFrontendServiceContainer } from '@phi/frontend/service-container';

type Operation = 'Union' | 'Subtract' | 'Intersect';

const SelectOperation = FormSelect<Operation>();

type MoveOperation = 'vertex' | 'selected_objects' | 'entire_body';

const move_operations: Array<Entry<MoveOperation>> = [
    { value: 'vertex', text: 'Only this vertex' },
    { value: 'selected_objects', text: 'All selected objects' },
    { value: 'entire_body', text: 'Entrire body' },
];

const SelectMoveOperation = FormSelect<MoveOperation>();

export default defineComponent({
    props: {
        show: { required: true, type: Boolean },
        app: { required: true, type: Object as PropType<IFrontendServiceContainer> },
    },

    emits: {
        'update:show': (x: boolean) => true,
    },

    data() {
        return {
            //model_bodies: [] as number[],
            model_bodies: [] as Array<readonly [number]>,

        };
    },

    computed: {
        body() {
            return [
                h('div', { class: 'mt-5' }, [
                    h('p', 'Current coordinates of selected vertex/vertices (in order of selection):'),
                    h('section', this.model_bodies.map(([i]) =>
                        h('div', { innerHTML: `Body ${i} Select Hide Show
                        <input class='form-control sr-only' type='checkbox' name='proportional'
                            id='selectBody${i}'>
                        <div class='phi-custom-checkbox'>
                            <svg class='phi-custom-checkbox__icon' width='16' height='16'>
                                <use xlink:href='#arrow-check'></use>
                            </svg>
                        </div>

                        <input class='form-control sr-only' type='checkbox' name='proportional'
                        id='hideBody${i}'>
                    <div class='phi-custom-checkbox'>
                        <svg class='phi-custom-checkbox__icon' width='16' height='16'>
                            <use xlink:href='#arrow-check'></use>
                        </svg>
                    </div>
                    <label for='lockFirstSelected' class='label label--with-checkbox'>
                    <input class='form-control sr-only' type='checkbox' name='proportional' id='myid'>
                    <div class='phi-custom-checkbox'>
                        <svg class='phi-custom-checkbox__icon' width='16' height='16'>
                            <use xlink:href='#arrow-check'></use>
                        </svg>
                    </div>
                    <div class='label__text'>Lock first selected vertex</div>
                </label>

                <div class='scale-options'>
    <label for='modelProportionally' class='label label--with-checkbox'>
        <input class='form-control sr-only' type='checkbox' name='proportional'
            id='modelProportionally'>
        <div class='phi-custom-checkbox'>
            <svg class='phi-custom-checkbox__icon' width='16' height='16'>
                <use xlink:href='#arrow-check'></use>
            </svg>
        </div>
        <div class='label__text'>Rescale proportionally</div>
    </label>
    <label for='lockFirstSelected' class='label label--with-checkbox'>
        <input class='form-control sr-only' type='checkbox' name='proportional' id='lockFirstSelected'>
        <div class='phi-custom-checkbox'>
            <svg class='phi-custom-checkbox__icon' width='16' height='16'>
                <use xlink:href='#arrow-check'></use>
            </svg>
        </div>
        <div class='label__text'>Lock first selected vertex</div>
    </label>
</div>

                        `}))),
                ]),
            ];
        },
    },

    methods: {
        cancel() {
            this.$emit('update:show', false);
        },

        confirm() {
            this.$emit('update:show', false);
        },

        reset() {
            //this.model_bodies = uil_get_model_bodies();
            this.model_bodies = model_bodies();
        },
    },

    watch: {
        show() {
            const model_bodies1 = uil_get_model_bodies();
            model_bodies1.forEach(function (bid){
                const selectstr = '#bodyselect' + Number(bid);
                $('selectstr').on('click', uid_select_all_objects(Number(bid)));

            });
            this.reset();
        }
    },

    render() {
        return h(Dialog, {
            show: this.show,
            'onUpdate:show': () => this.$emit('update:show', false),
            close_label: 'Cancel',
            onClose: this.cancel,
            onConfirm: this.confirm,
            confirm_label: 'Set',
            id: 'booleanOpsModal',
            title: 'Booleans',
            width: 'extra-narrow',
        }, () => this.body);
    }
});

const model_bodies = () => pipe(
    get_bogus_model_bodies(),
    enumerate,
    map(([i]) => [i] as const),
    of,
);

function get_bogus_model_bodies() {
    //return uil_get_model_bodies();
    return [1];
}
